import { ParticipantExam } from "../types/components";

export const getResponsiblePersons = (
  responsiblePersons: ParticipantExam["exam"]["responsible_persons"],
) => {
  // TODO: handle multiple responsible persons on a exam
  return responsiblePersons?.[0]
    ? `${responsiblePersons?.[0]?.responsible_person?.first_name} ${responsiblePersons?.[0]?.responsible_person?.last_name}`
    : "";
};
